/* eslint-disable spire/export-styles */
import Zone from "@insite/client-framework/Components/Zone";
import { ColumnAlignment } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ButtonWrapper } from "@insite/mobius/Button";
import { FormFieldStyle, FormInputWrapper } from "@insite/mobius/FormField";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridOffset, GridWrapper } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridItemStyle, GridWidths } from "@insite/mobius/GridItem";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

const enum fields {
    columns = "columns",
    gap = "gap",
    alignment = "alignment",
    reflow = "reflow",
    cssClass = "cssClass",
}

export interface RowStyles {
    wrapper?: InjectableCss;
}

export const rowStyles: RowStyles = {
    wrapper: {
        css: css`
            &.footerContainer {
                margin-bottom: 1rem;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                margin-bottom: 0rem;
                            `,
                            null,
                            null,
                            null,
                        ],
                        "max",
                    )}
                div[class^="Wrapper"] {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                css`
                                    display: flex;
                                    justify-content: center;
                                `,
                                null,
                                null,
                                null,
                            ],
                            "max",
                        )}
                }
                > ${GridOffset} > ${GridItemStyle} {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                css`
                                    padding: 0.5rem 0;
                                `,
                                null,
                                null,
                                null,
                            ],
                            "max",
                        )}
                }
            }
            &.footerBorder {
                border-top: 1px solid ${getColor("common.border")};
                margin: 0 auto;
                max-width: 1440px;
                > ${GridOffset} {
                    width: 100%;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [null, null, null, null, null], "min")}
                }
            }
            &.newsLetter {
                margin: 0 auto;
                max-width: 1440px;
                > ${GridOffset} {
                    background: ${getColor("common.background")};
                    border-radius: 4px;
                    margin: -6.5rem auto 0rem;
                    /* width: 1280px; */
                    padding: 1rem;
                    border: 0.5px solid ${getColor("common.border")};
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                css`
                                    margin-top: 1rem;
                                    border-radius: 0px;
                                    margin-bottom: 2rem;
                                `,
                                null,
                                null,
                                null,
                            ],
                            "max",
                        )}
                }
                > ${GridItemStyle}:last-child {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                css`
                                    padding: 0.5rem 0;
                                `,
                                null,
                                null,
                                null,
                            ],
                            "max",
                        )}
                }
                div[class^="Wrapper"] {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                css`
                                    display: flex;
                                    justify-content: center;
                                `,
                                null,
                                null,
                                null,
                            ],
                            "max",
                        )}
                }
            }
            &.addToCart {
                padding: 0px 15px 0px;
                > ${GridOffset} {
                    flex-direction: column;
                    > ${GridItemStyle}:first-child {
                        max-width: 100%;
                        flex-basis: 100%;
                        padding: 0px 0px 8px;
                        align-items: center;
                        > div[class^="Wrapper"] {
                            ${FormFieldStyle} {
                                margin-top: 0px;
                                display: inline;
                                /* flex-direction: row; */
                                /* align-items: center; */
                                ${FormInputWrapper} {
                                    margin-top: 0px;
                                }
                                label {
                                    display: inline;
                                    /* flex-basis: 29%; */
                                    /* max-width: 29%; */
                                    font-size: 1rem;
                                    margin-right: 12px;
                                    ${({ theme }: { theme: BaseTheme }) =>
                                        breakpointMediaQueries(theme, [
                                            null,
                                            null,
                                            css`
                                                flex-basis: 29%;
                                                max-width: 29%;
                                            `,
                                            css`
                                                flex-basis: 32%;
                                                max-width: 32%;
                                            `,
                                            null,
                                        ])}
                                }
                                > div[class^="FormInputWrapper"] {
                                    flex-basis: 25%;
                                    max-width: 25%;
                                    margin-top: 2px;
                                    display: inline-block;
                                    input {
                                        background: #e8e9eb;
                                        border: 1px solid #d8d8d8;
                                        border-radius: 4px;
                                        padding: 0px 8px 0 8px !important;
                                        height: 30px !important;
                                    }
                                }
                            }
                        }
                    }
                    > ${GridItemStyle}:last-child {
                        max-width: 100%;
                        flex-basis: 100%;
                        margin-top: 0px;
                        padding: 0px !important;
                        align-items: flex-end;
                        ${ButtonWrapper} {
                            min-height: 40px;
                            font-size: 18px !important;
                            ${IconWrapper} {
                                height: 20px;
                                width: 20px;
                                > svg {
                                    height: 20px;
                                    width: 20px;
                                }
                            }
                        }
                    }
                }
                + ${GridWrapper} {
                    > ${GridOffset} {
                        > ${GridItemStyle} {
                            padding: 8px 15px;
                            > div[class^="Wrapper"] {
                                > ${ButtonWrapper} {
                                    background-color: ${getColor("primary")};
                                    color: #fff;
                                    > span {
                                        font-weight: 500;
                                    }
                                    &:hover {
                                        background-color: #b93c3c;
                                        border: 1px solid gray;
                                        /* background-image: linear-gradient(to right, #622222, #953636); */
                                        span {
                                            text-decoration: underline;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            &.partNumber {
                /* margin-bottom: 10px; */
                /* border-bottom: 1px solid ${getColor("common.border")}; */
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            border-bottom: none;
                        `,
                        css`
                            border-bottom: none;
                        `,
                        css`
                            border-bottom: 1px solid #c5c5c7;
                        `,
                        css`
                            border-bottom: 1px solid #c5c5c7;
                        `,
                        css`
                            border-bottom: 1px solid #c5c5c7;
                        `,
                    ])}

                > ${GridOffset} {
                    ${GridItemStyle} {
                        padding: 0px;
                        > div[class^="Wrapper"] {
                            p {
                                font-size: 1rem;
                                /* margin-bottom: 10px; */
                                span {
                                    /* white-space: nowrap; */
                                }
                            }
                        }
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                null,
                                null,
                                null,
                                null,
                                css`
                                    flex-basis: auto;
                                    max-width: inherit;
                                    margin-bottom: 10px;
                                    margin-right: 10px;
                                `,
                            ])}
                    }
                }
                + div {
                    padding: 10px 0px;
                    padding-bottom: 0px;
                    /* border-top: 1px solid ${getColor("common.border")}; */
                    section {
                        > div:first-child {
                            > div {
                                span {
                                
                                }
                            }
                        }
                        > div:last-child {
                            display: none;
                        }
                    }
                }
            }
            &.placeOrderButtonCheckoutPage {
                div[class^="sc"] {
                    justify-content: flex-start;
                    > button:first-child {
                        display: none;
                    }
                }
            }
            &.quickOrder {
                > ${GridOffset} {
                    > ${GridItemStyle}:first-child {
                        padding: 15px;
                        border: 1px solid rgb(197, 197, 199);
                        margin-top: 20px;
                        > div[class^="Wrapper"] {
                            > ${GridWrapper}:last-child {
                                > ${GridOffset} {
                                    > ${GridItemStyle}:last-child {
                                        > ${ButtonWrapper} {
                                            padding: 0px;
                                        }
                                    }
                                    > ${TypographyStyle} {
                                        margin-left: 15px;
                                        margin-right: 15px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        `,
    },
};

const styles = rowStyles;

interface Props extends WidgetProps {
    fields: {
        [fields.columns]: GridWidths[];
        [fields.gap]: number;
        [fields.alignment]: ColumnAlignment[];
        [fields.reflow]: boolean;
        [fields.cssClass]: string;
    };
}

const mobileColumnsRef: { [key: number]: GridWidths | GridWidths[] } = {
    1: [3, 3, 1, 1, 1],
    2: [4, 4, 2, 2, 2],
    3: [6, 6, 3, 3, 3],
    4: [6, 6, 4, 4, 4],
    5: [12, 12, 5, 5, 5],
    6: [12, 12, 6, 6, 6],
    7: [12, 12, 7, 7, 7],
    8: [12, 12, 8, 8, 8],
    9: [12, 12, 9, 9, 9],
    10: [12, 12, 10, 10, 10],
    11: [12, 12, 11, 11, 11],
    12: 12,
};

const convertToResponsive = (column: GridWidths): GridWidths | GridWidths[] => {
    return mobileColumnsRef[column] || column;
};

const Row: React.FunctionComponent<Props> = (props: Props) => {
    const {
        fields: { columns, gap, alignment, reflow, cssClass },
        id,
    } = props;

    const columnElements: JSX.Element[] = [];

    for (let x = 0; x < columns.length; x += 1) {
        const align = alignment[x] ? alignment[x] : "top";
        columnElements.push(
            <GridItem key={x} width={reflow ? convertToResponsive(columns[x]) : columns[x]} align={align}>
                <Zone contentId={id} zoneName={`Content${x}`} />
            </GridItem>,
        );
    }

    return (
        <GridContainer className={cssClass} gap={gap || 0} {...styles.wrapper}>
            {columnElements}
        </GridContainer>
    );
};

const advancedTab = {
    displayName: "Advanced",
    sortOrder: 1,
};

const widgetModule: WidgetModule = {
    component: Row,
    definition: {
        group: "Basic",
        icon: "distribute-spacing-vertical",
        displayName: "SE Custome Row",
        fieldDefinitions: [
            {
                name: fields.columns,
                displayName: "Layout",
                editorTemplate: "ColumnsField",
                defaultValue: [4, 4, 4],
                fieldType: "General",
                sortOrder: 1,
                validate: value => (value.length > 0 ? null : "Please enter a valid layout."),
            },
            {
                name: fields.reflow,
                displayName: "Use default reflow for responsive screens sizes",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
            {
                name: fields.gap,
                displayName: "Gap Between Items",
                editorTemplate: "IntegerField",
                defaultValue: 0,
                fieldType: "General",
                max: 1000,
                min: 0,
                sortOrder: 10,
            },
            {
                name: fields.alignment,
                displayName: "Column Alignment",
                editorTemplate: "ColumnAlignmentField",
                defaultValue: [],
                fieldType: "General",
                sortOrder: 1,
                tab: advancedTab,
            },
            {
                name: fields.cssClass,
                displayName: "Add CSS Class",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
